import {
  AGENT_TASK_UPDATE_ACTIONS,
  type AgentTaskUpdateAction,
} from "../../teams/agent-task-update-constants";

// A Map, not an object: an action named after an Object member would otherwise
// read the prototype's value. `satisfies` fails the build on a new action.
export const updateTaskLabels: ReadonlyMap<string, string> = new Map(
  Object.entries({
    [AGENT_TASK_UPDATE_ACTIONS.BLOCK]: "Blocked a task",
    [AGENT_TASK_UPDATE_ACTIONS.COMPLETE]: "Completed a task",
    [AGENT_TASK_UPDATE_ACTIONS.FAIL]: "Marked a task failed",
    [AGENT_TASK_UPDATE_ACTIONS.HEARTBEAT]: "Kept a task alive",
    [AGENT_TASK_UPDATE_ACTIONS.PROGRESS]: "Reported progress on a task",
    [AGENT_TASK_UPDATE_ACTIONS.RELEASE]: "Released a blocked task",
  } satisfies Record<AgentTaskUpdateAction, string>),
);
